var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 18",
    style: {
      enableBackground: "new 0 0 29 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C2F49;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_xDBC0__xDF07_",
    className: "st0",
    d: "M24.5,6c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7s-0.4-0.3-0.7-0.3 H3.8c-0.3,0-0.5,0.1-0.7,0.3S2.8,4.8,2.8,5.1s0.1,0.5,0.3,0.7S3.5,6,3.8,6H24.5z M24.5,10.9c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7 c0-0.3-0.1-0.5-0.3-0.7s-0.4-0.3-0.7-0.3H3.8c-0.3,0-0.5,0.1-0.7,0.3S2.8,9.8,2.8,10c0,0.3,0.1,0.5,0.3,0.7s0.4,0.3,0.7,0.3H24.5z  M24.5,15.9c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7c0-0.2-0.1-0.5-0.3-0.6S24.7,14,24.5,14H3.8c-0.3,0-0.5,0.1-0.7,0.3 s-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.3,0.7s0.4,0.3,0.7,0.3H24.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.eec7946540fbb4ca4cae8d9603ccc445.svg";
export { ForwardRef as ReactComponent };